import React, { useCallback } from 'react';
import {
  View,
  Text,
  Modal,
  KeyboardAvoidingView,
  Platform,
} from 'react-native';
import { StatsInfo } from '../../StatsBar/StatsBar';
import StatsModalStyles from './StatsModal.styles';
import ModalTitle from '../ModalTitle/ModalTitle';
import { useTranslation } from '@oolio-group/localization';

export interface StatsModalProps {
  info: StatsInfo;
  onClose?: () => void | Promise<void>;
  visible: boolean;
}
const StatsModal: React.FC<StatsModalProps> = ({
  info,
  onClose = () => undefined,
  visible,
}) => {
  const styles = StatsModalStyles();
  const { translate } = useTranslation();

  const onRequestClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Modal
      visible={visible}
      animationType="fade"
      transparent
      onRequestClose={onRequestClose}
      supportedOrientations={['landscape', 'landscape-left', 'landscape-right']}
    >
      <KeyboardAvoidingView
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        style={styles.background}
      >
        <View style={styles.container}>
          <ModalTitle
            title={translate('kitchenDisplay.statsModalTitle')}
            onDismiss={onRequestClose}
          />
          <View style={styles.statsContainer}>
            <View style={styles.statGroup}>
              <Text style={styles.statLabel}>
                {translate('kitchenDisplay.avgTime')}
              </Text>
              <Text style={styles.statValue}>
                {info.avgTime !== null
                  ? info.avgTime +
                    (info.avgTime <= 1.0
                      ? ` ${translate('kitchenDisplay.minute')}`
                      : ` ${translate('kitchenDisplay.minutes')}`)
                  : `0 ${translate('kitchenDisplay.minute')}`}
              </Text>
            </View>
            <View style={styles.statGroup}>
              <Text style={styles.statLabel}>
                {translate('kitchenDisplay.longestTime')}
              </Text>
              <Text style={[styles.statValue, styles.longest]}>
                {info.longest !== null
                  ? info.longest +
                    (info.longest <= 1.0
                      ? ` ${translate('kitchenDisplay.minute')}`
                      : ` ${translate('kitchenDisplay.minutes')}`)
                  : `0 ${translate('kitchenDisplay.minute')}`}
              </Text>
            </View>
            <View style={styles.statGroup}>
              <Text style={styles.statLabel}>
                {translate('kitchenDisplay.dockets')}
              </Text>
              <Text style={styles.statValue}>
                {info.dockets !== null ? info.dockets : '0'}
              </Text>
            </View>
            <View style={styles.statGroup}>
              <Text style={styles.statLabel}>
                {translate('kitchenDisplay.items')}
              </Text>
              <Text style={styles.statValue}>
                {info.items !== null ? info.items : '0'}
              </Text>
            </View>
          </View>
        </View>
      </KeyboardAvoidingView>
    </Modal>
  );
};

export default StatsModal;
